module.exports = "<div id=app-sidebar><photo-and-name></photo-and-name><anchor-list></anchor-list></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSidebar.vue
 ** module id = 217
 ** module chunks = 0
 **/